import { ColumnsType } from "antd/es/table";
import classNames from "classnames";

// Interface type
export interface PipelineData {
  key: string;
  name: string;
  client: string;
  source: string;
  startDate: string;
  startTime: string;
  status: string;
  executionTime: string;
  completion: string;
}
// Add at the top of your file
 export interface RawPipeline {
  "Pipeline Name": string;
  "Client Name": string;
  "Sources": string;
  "Start DateTime": string;
  "Current Status": string;
  "Execution Time": string | number;
  "Completion": string | number;
}
// Column definitions
export const pipelineColumns: ColumnsType<PipelineData> = [
  { title: "Pipeline Name", dataIndex: "name", key: "name" },
  { title: "Client Name", dataIndex: "client", key: "client" },
  { title: "Sources", dataIndex: "source", key: "source" },
  { title: "Start Date", dataIndex: "startDate", key: "startDate" },
  { title: "Start Time", dataIndex: "startTime", key: "startTime" },
  {
    title: "Current Status",
    dataIndex: "status",
    key: "status",
    render: (text: string) => {
      const lowerText = text?.toLowerCase();
      let badgeClass = "status-badge--default";

      if (lowerText === "success" || lowerText === "succeeded") {
        badgeClass = "status-badge--success";
      } else if (lowerText === "failed") {
        badgeClass = "status-badge--failed";
      }

      return (
        <span className={classNames("status-badge", badgeClass)} >{text} </span>
      );
    },
  },
  {
    title: "Execution Time",
    dataIndex: "executionTime",
    key: "executionTime",
  },
  {
    title: "Completion",
    dataIndex: "completion",
    key: "completion",
  },
];
